export const OnlineAttendeesLocView = function (refresh_interval = 15000) {
  const gid = _current_expoid();
  const tpl = `
<template x-for="(item, index) in items">
<div>
  <template x-if="(item.items ?? []).length > 0">
      <details x-bind:open="isOpen(item)" x-on:toggle="onToggle($event, item)">
          <summary>
              <div class="item" :style="{'--w': item.width}" :title="item.title"><a x-text="item.title"></a><span class="count" x-text="item.count"></span></div>
          </summary>
          <div class="sub-items">
              <template x-for="(sub_item, sub_index) in item.items">
                  <div class="item" :style="{'--w': sub_item.width}" :title="sub_item.title">
                      <a x-text="sub_item.title"></a><span class="count" x-text="sub_item.count"></span>
                  </div>
              </template>
          </div>
      </details>
  </template>
  <template x-if="(item.items ?? []).length == 0">
      <div class="item" :style="{'--w': item.width}" :title="item.title"><a x-text="item.title"></a><span class="count" x-text="item.count"></span></div>
  </template>
</div>
</template>
`;
  const getData = () => {
    return fetch(`/twilio/wom/info?gid=${gid}`)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        return data;
      });
  };
  const processItems = (itmes, maxW = 0) => {
    if (!itmes || itmes.length === 0) {
      return [];
    }
    if (maxW <= 0) {
      maxW = Math.max(...itmes.map(x => x["count"]));
    }
    return itmes.map(x => ({...x, "width": x["count"] / maxW, items: processItems(x["items"], maxW)}));
  }
  return {
    items: [],
    openStatus: {},
    timer: null,
    isOpen(item) {
      return this.openStatus[item.key] ?? false;
    },
    init() {
      this.$el.innerHTML = tpl;
      const processData = () => {
        getData().then((data) => {
          this.items = processItems(data);
          const total_count = data.map(x => x["count"]).reduce((accumulator, currentValue) => accumulator + currentValue, 0);
          document.dispatchEvent(new CustomEvent('sn-online-attendees-total-count-change', {
            detail: {
              total_count,
            }
          }));
        });
      };
      processData();
      this.timer = setInterval(() => {
        processData();
      }, refresh_interval);
    },
    destroy() {
      clearInterval(this.timer);
    },
    onToggle(e, item) {
      this.openStatus[item.key] = e.target.open;
    }
  };
}
